<template>
  <div class="pagination" v-if="pagesArr.length">
    <a
      :href="getPageLink(firstPage, currentPage == 1)"
      :class="[
        'slide-nav nav-first',
        { 'nav-disabled': currentPage == 1 || isLoadMoreDisabled },
      ]"
      @click="updatePage(firstPage, $event)"
    >
      <span>{{ firstPageBtn }}</span>
    </a>
    <a
      :href="getPageLink(currentPage - 1, currentPage == 1)"
      :class="[
        'slide-nav nav-left',
        { 'nav-disabled': currentPage == 1 || isLoadMoreDisabled },
      ]"
      @click="updatePage(currentPage - 1, $event)"
    >
      <span>{{ prevPageBtn }}</span>
    </a>
    <div class="pagination-number">
      <a
        v-for="p in pagesArr"
        v-bind:key="`page_${p.text}`"
        :class="[
          { active: p.text == currentPage },
          { 'nav-disabled': isLoadMoreDisabled },
        ]"
        :href="getPageLink(p.text)"
        @click="updatePage(p.text, $event)"
        >{{ p.text }}</a
      >
    </div>
    <a
      :href="getPageLink(currentPage + 1, currentPage == lastPage)"
      :class="[
        'slide-nav nav-right',
        { 'nav-disabled': currentPage == lastPage || isLoadMoreDisabled },
      ]"
      @click="updatePage(currentPage + 1, $event)"
    >
      <span>{{ nextPageBtn }}</span>
    </a>
    <a
      :href="getPageLink(lastPage, currentPage == lastPage)"
      :class="[
        'slide-nav nav-last',
        { 'nav-disabled': currentPage == lastPage || isLoadMoreDisabled },
      ]"
      @click="updatePage(lastPage, $event)"
    >
      <span>{{ lastPageBtn }}</span>
    </a>
  </div>
</template>

<script>
import { urlCorrections } from "../../assets/js/common";
export default {
  props: [
    "onPageChange",
    "currentPage",
    "totalRecords",
    "recordsPerView",
    "isLoadMoreDisabled",
    "baseUrl",
  ],
  data() {
    return {
      firstPageBtn: "first",
      lastPageBtn: "last",
      prevPageBtn: "Previous",
      nextPageBtn: "Next",
      firstPage: 1,
      pageBubbleLimit: 5, // count of page numbers in pagination
    };
  },
  computed: {
    lastPage() {
      let absolutePages = Math.floor(this.totalRecords / this.recordsPerView); // count of pages by recordsPerView
      let extraPage = this.totalRecords % this.recordsPerView ? 1 : 0; // if some records remaining count it 1 page
      let totalPages = absolutePages + extraPage;
      return totalPages >= this.firstPage ? totalPages : this.firstPage;
    },
    pagesArr() {
      return this.createPageBubbles();
    },
  },
  methods: {
    getPageLink(pageNum, blockLink) {
      if (blockLink) {
        return null;
      }
      if (this.baseUrl) {
        let finalLink = `${this.baseUrl}${pageNum}`;
        if (pageNum == 1) {
          finalLink = finalLink.replace(`/page/${pageNum}`, "");
        }
        return urlCorrections(finalLink);
      }
    },
    updatePage(pageNum, event) {
      event.stopPropagation();
      event.preventDefault();
      if (this.currentPage !== pageNum) {
        this.onPageChange(pageNum);
      }
    },
    createPageBubbles() {
      let start, end;
      if (this.pageBubbleLimit >= this.lastPage) {
        (start = this.firstPage), (end = this.lastPage);
      } else {
        let halfOfLen = Math.floor(this.pageBubbleLimit / 2);
        if (this.currentPage - halfOfLen > 0) {
          let possibleStart = this.currentPage - halfOfLen;
          if (possibleStart + (this.pageBubbleLimit - 1) <= this.lastPage) {
            start = possibleStart;
            end = possibleStart + (this.pageBubbleLimit - 1);
          } else {
            start = this.lastPage - (this.pageBubbleLimit - 1);
            end = this.lastPage;
          }
        } else {
          start = this.firstPage;
          if (start + (this.pageBubbleLimit - 1) <= this.lastPage) {
            end = start + (this.pageBubbleLimit - 1);
          } else {
            end = this.lastPage;
          }
        }
      }

      let arr = [];
      for (let i = start; i <= end; i++) {
        arr.push({ text: i });
      }
      return arr;
    },
  },
};
</script>